import { useCallback, useMemo } from 'react';
import { isAfter, format, startOfDay } from 'date-fns';
import { useIoContext } from "../../../../contexts";
import { useServiceBillingDetails } from "../../../../hooks/reactQuery/queries/useServiceBillingDetails";
import { serviceModel } from "../../../../models";
import { pluralize } from "../../../../utils/pluralize";
import { StartAutomaticBillingAtControlDropdownMenuItem } from "../StartAutomaticBillingAtControl";
export const useCallOuts = _ref => {
  let {
    testIds,
    relationshipEffectiveDate,
    service,
    selectedItem,
    isChecked
  } = _ref;
  const {
    StartAutomaticBillingAtControlTestIds
  } = testIds;
  const {
    getNow
  } = useIoContext();
  const getToday = useCallback(() => startOfDay(getNow()), [getNow]);
  const isProrated = serviceModel.isProrated(service);
  const {
    nextBillingDate,
    periods
  } = useServiceBillingDetails({
    service,
    relationshipEffectiveDate: relationshipEffectiveDate
  });
  const startBillingAt = serviceModel.startBillingAt(service);
  const shouldShowProrateWarning = useMemo(() => {
    if (!isProrated && startBillingAt && nextBillingDate) {
      return nextBillingDate.getTime() !== startBillingAt.getTime();
    }
    return false;
  }, [nextBillingDate, startBillingAt, isProrated]);
  return useMemo(() => {
    const _callouts = [];
    if (!isChecked) {
      return _callouts;
    }
    if (selectedItem === StartAutomaticBillingAtControlDropdownMenuItem.SpecificDate && startBillingAt) {
      if (isAfter(startBillingAt, getToday())) {
        _callouts.push({
          dataTestid: StartAutomaticBillingAtControlTestIds.Callouts.FutureDate(),
          text: "If the proposal is signed after ".concat(format(startBillingAt, 'MMM d, yyyy'), ", any charges for prior periods will be invoiced upon approval.")
        });
      }
      if (shouldShowProrateWarning) {
        _callouts.push({
          dataTestid: StartAutomaticBillingAtControlTestIds.Callouts.Proration(),
          text: 'As the selected date doesn’t match the billing day, an additional full invoice will be issued. You can adjust the date or use “first month proration” to align payments.'
        });
      }
      if (periods && periods > 0) {
        _callouts.push({
          dataTestid: StartAutomaticBillingAtControlTestIds.Callouts.PriorPeriods(),
          text: "Invoices for ".concat(periods, " prior ").concat(pluralize('periods', periods), " will be issued once the proposal is approved. If the proposal is signed after ").concat(format(startBillingAt, 'MMM d, yyyy'), ", additional invoices for earlier periods will also be issued.")
        });
      }
    }
    return _callouts;
  }, [selectedItem, isChecked, startBillingAt, shouldShowProrateWarning, periods]);
};